var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58284 0.436749L0.173745 5.43675C-0.0579523 5.77657 -0.0579524 6.2236 0.173745 6.56342L3.58284 11.5634C3.89396 12.0197 4.51609 12.1374 4.9724 11.8263C5.42871 11.5152 5.54641 10.8931 5.23529 10.4367L2.25918 6.00018L5.23529 1.56342C5.54641 1.10711 5.42871 0.484981 4.9724 0.173859C4.51609 -0.137264 3.89396 -0.0195638 3.58284 0.436749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.53d052176dac9aeca222d90a8b7d0959.svg";
export { ForwardRef as ReactComponent };